export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

export const formatDaysList = (days) => {
  if (!days || days.length === 0) return 'No scheduled days';
  return days.join(', ');
};